
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5.091A17.2 17.2 0 000 16c3.468 8.837 13.443 13.189 22.279 9.721A17.188 17.188 0 0032 16 17.2 17.2 0 0016 5.091zM16 8a14.21 14.21 0 0112.829 8C25.358 23.085 16.8 26.015 9.715 22.544A14.288 14.288 0 013.171 16 14.21 14.21 0 0116 8zm0 1.455a6.546 6.546 0 106.545 6.547V16A6.556 6.556 0 0016 9.455zm0 2.909A3.636 3.636 0 1112.364 16 3.637 3.637 0 0116 12.364z"}})])
          )
        }
      }
    